import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import Home from '../views/Home.vue'
import AdRevenueQuery from '../components/AdRevenueQuery.vue'
import SystemConfigManagement from '../components/SystemConfigManagement.vue'
import AppInfoManagement from '../components/AppInfoManagement.vue'
import UserManagement from '../components/UserManagement.vue'
import UserWithdrawalManagement from '../components/UserWithdrawalManagement.vue'
import RiskManagement from '../components/RiskManagement.vue'
import CoinFlowManagement from '../components/CoinFlowManagement.vue'
import AdPoolSettlementManagement from '../components/AdPoolSettlementManagement.vue'
import LeaderLevelManagement from '../components/LeaderLevelManagement.vue'
import InviteReward from '../components/InviteReward.vue'
import InviteRewardFlowManagement from '../components/InviteRewardFlowManagement.vue'
import WithdrawalOptionManagement from '../components/WithdrawalOptionManagement.vue'
import NewbieLessonManagement from '../components/NewbieLessonManagement.vue'
import AdminManagement from '../components/AdminManagement.vue'
import AdminLoginLog from '../components/AdminLoginLog.vue'

// 忽略重复导航错误
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

Vue.use(Router)

const businessChildren = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { title: '首页' }
  },
  {
    path: '/ad-revenue',
    name: 'AdRevenueQuery',
    component: AdRevenueQuery
  },
  {
    path: '/system/config',
    name: 'SystemConfigManagement',
    component: SystemConfigManagement
  },
  {
    path: '/system/app',
    name: 'AppInfoManagement',
    component: AppInfoManagement
  },
  {
    path: '/newbie-lesson',
    name: 'NewbieLessonManagement',
    component: NewbieLessonManagement,
    meta: { title: '新手课堂' }
  },
  {
    path: '/user-management',
    name: 'UserManagement',
    component: UserManagement
  },
  {
    path: '/user-withdrawal',
    name: 'UserWithdrawalManagement',
    component: UserWithdrawalManagement
  },
  {
    path: '/withdrawal-option',
    name: 'WithdrawalOptionManagement',
    component: WithdrawalOptionManagement,
    meta: { title: '提现档位配置' }
  },
  {
    path: '/leader-level',
    name: 'LeaderLevelManagement',
    component: LeaderLevelManagement,
    meta: { title: '团长等级配置' }
  },
  {
    path: '/invite-reward',
    name: 'InviteReward',
    component: InviteReward,
    meta: { title: '直邀提现奖励' }
  },
  {
    // 勿用 /admin-*：线上 Nginx 常把 location /admin 代理到后端，会与 API 前缀冲突
    path: '/system/admins',
    name: 'AdminManagement',
    component: AdminManagement,
    meta: { title: '管理员管理' }
  },
  {
    path: '/system/login-logs',
    name: 'AdminLoginLog',
    component: AdminLoginLog,
    meta: { title: '系统日志' }
  },
  {
    path: '/risk-management',
    name: 'RiskManagement',
    component: RiskManagement,
    meta: { title: '风控管理' }
  },
  {
    path: '/coin-flow',
    name: 'CoinFlowManagement',
    component: CoinFlowManagement,
    meta: { title: '金币明细' }
  },
  {
    path: '/invite-reward-flow',
    name: 'InviteRewardFlowManagement',
    component: InviteRewardFlowManagement,
    meta: { title: '奖励明细' }
  },
  {
    path: '/ad-pool-settlement',
    name: 'AdPoolSettlementManagement',
    component: AdPoolSettlementManagement,
    meta: { title: '叠包开包流水' }
  }
]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/data-dashboard',
      redirect: '/home'
    },
    {
      path: '/app',
      component: MainLayout,
      redirect: '/home',
      children: businessChildren
    }
  ]
})

// 全局路由守卫：后台账号（role 0/1）均可登录，权限统一
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const role = parseInt(localStorage.getItem('role'), 10)

  if (to.path === '/login' || to.path === '/') {
    if (token) {
      next('/home')
    } else if (to.path === '/') {
      next('/login')
    } else {
      next()
    }
  } else {
    if (token) {
      if (role !== 0 && role !== 1) {
        localStorage.removeItem('token')
        localStorage.removeItem('role')
        next('/login')
      } else {
        next()
      }
    } else {
      next('/login')
    }
  }
})

export default router
